<template>
  <div>
    <!--    打印缴费单-->
    <div class="printPaymentSlip">
      <van-nav-bar
          title="打印缴费单"
          left-arrow
          class="customNavBar"
          @click-left="onClickLeft"
      />
      <div class="printPaymentSlip_top">
        <div v-html="textContent" class="textContent">
        </div>
        <div class="sealImg" v-if="sealImg">
          <img :src="sealImg" alt="">
        </div>
        <div class="signStyle" v-if="isSign">
          <p>
            当事人签字
          </p>
          <div v-if="signImg== ''" class="defaultSign" @click="$router.push({
          path:'/signPage',query:{
            noticeNo,
             fullPath:$route.fullPath
          }
          })">
            点击进行签字
          </div>
          <div v-else class="signDiv">
            <span @click="$router.push({
          path:'/signPage',query:{
            noticeNo,
             fullPath:$route.fullPath
          }
          })">
              点击重新签字
            </span>
            <img :src="signImg" alt="" class="signImg">
          </div>
        </div>
        <div class="signTime" v-if="issignTime">
          {{ signTime }}
        </div>
        <van-button
            block
            class="printconfirm"
            round
            type="info"
            @click="printPay"
        >打印缴款书
          <img
              class="blueSha"
              src="../../assets/img/blueshadow.png"
              alt=""
          />
        </van-button>
      </div>
      <!--打印转图片base区域 -->
      <div class="printPaymentSlip_top" id="textContent" style="min-height:auto; position: fixed;z-index: -10;">
        <div v-html="textContent" class="textContent" style="padding: 8px 0;">
        </div>
        <div class="sealImg" v-if="sealImg">
          <img :src="baseUrl" alt="" style="height: 230px;" crossorigin="anonymous">
        </div>
        <div class="signStyle" v-if="isSign">
          <p>
            当事人签字
          </p>
          <div class="signDiv">
            <img :src="signImg" alt="" class="signImg " id="toBase64">
          </div>
        </div>
        <div class="signTime" v-if="issignTime">
          {{ signTime }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas"

export default {
  name: "printpaymentSlip",
  data() {
    return {
      noticeNo: '',
      textContent: '',
      sealImg: '',
      signTime: '',
      issignTime: false,
      isSign: false,
      signImg: "",
      baseUrl: ''
    }
  },
  mounted() {
    this.noticeNo = this.$route.query.noticeNo
    this.getData()

    let obj = JSON.parse(localStorage.getItem('signObj'))
    let {dsrSignet, signTime} = obj || {}
    if (dsrSignet) {
      this.signImg = dsrSignet
    }
    if (signTime) {
      this.signTime = signTime
    }
    localStorage.setItem('signObj', null)

  },
  methods: {
    printPay() {
      if (this.isSign) {
        if (this.signImg == '') {
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            message: '签名不能为空'
          });
        } else {
          this.callPrint({
            dsrSignet: this.signImg,
            signTime: this.signTime,
            noticeNo: this.noticeNo
          })
        }
      } else {
        this.callPrint({
          noticeNo: this.noticeNo
        })
      }
    },
    callPrint(obj) {
      let printObj = {
        sealImg: this.sealImg,
        textContent: this.textContent,
        ...obj
      }

      let isAndroid = window.android?.sendModelTypeToJS() || '0'
      if (isAndroid == '0') {
        // let element = document.getElementById('textContent')
        // if(this.sealImg){
        //   console.log(1)
        //   this.converTimgUrlToBase64(this.sealImg).then(res => {
        //     this.baseUrl = res
        //     this.$nextTick(() => {
        //       html2canvas(element, {
        //         useCORS: true,
        //       }).then(function (canvas) {
        //         let base64Image = canvas.toDataURL("image/png");
        //         console.log(base64Image)
        //         window.android?.doPayPrint(base64Image)
        //       });
        //     })
        //   })
        // }else{
        //   console.log(2)
        //   this.$nextTick(() => {
        //     html2canvas(element, {
        //       useCORS: true,
        //     }).then(function (canvas) {
        //       let base64Image = canvas.toDataURL("image/png");
        //       console.log(base64Image)
        //       window.android?.doPayPrint(base64Image)
        //     });
        //   })
        // }
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          message: '当前设备暂不支持打印缴款书！！'
        });
        return
      } else {
        // let element = document.getElementById('textContent')
        // if (this.sealImg) {
        //   this.converTimgUrlToBase64(this.sealImg).then(res => {
        //     this.baseUrl = res
        //     this.$nextTick(() => {
        //       html2canvas(element, {
        //         useCORS: true,
        //       }).then(function (canvas) {
        //         let base64Image = canvas.toDataURL("image/png");
        //         window.android?.doPayPrint(base64Image)
        //       });
        //     })
        //   })
        // } else {
        //   this.$nextTick(() => {
        //     html2canvas(element, {
        //       useCORS: true,
        //     }).then(function (canvas) {
        //       let base64Image = canvas.toDataURL("image/png");
        //       window.android?.doPayPrint(base64Image)
        //     });
        //   })
        // }
        let obj = {
          signImg:this.signImg,
          deptSignet:this.sealImg,
          dsrSignet:this.isSign,
          signTime:this.signTime,
          content:this.textContent
        }
        window.android?.callAndroidPrint(JSON.stringify(obj))
      }
    },
    converTimgUrlToBase64(url) {
      return new Promise((resolve) => {
        let img = new Image()
        img.crossOrigin = 'Anonymous'
        img.src = url
        img.onload = () => {
          let base64 = this.getBase64Image(img)
          resolve(base64)
        }
      })
    },
    getBase64Image(img) {
      let canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      let ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, img.width, img.height)
      let ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase()
      return canvas.toDataURL("image/" + ext)
    },
    receiveQmValue(val) {
      this.signImg = val;
    },
    getData() {
      this.request({
        url: '/printDemandNote/getMessage',
        baseURL: process.env.VUE_APP_PAY_URL,
        params: {
          noticeNo: this.noticeNo
        }
      }).then(res => {
        if (res.data.code == 1000) {
          let {content, deptSignet, dsrSignet, signTime} = res.data.result
          // let {content, deptSignet, dsrSignet, signTime} = {
          //   deptSignet: '',
          //   signTime: '',
          //   dsrSignet: '',
          //   content: "<p style=\"line-height: 1.5;\">曲靖市宣威交通运政管理所</p>\n<p style=\"line-height: 1.5;\"><span style=\"font-size: 24px;\"><strong>简易程序(当场)处罚决定书</strong></span></p>\n<p style=\"line-height: 1.5;\">&nbsp;</p>\n<p style=\"line-height: 1.5;\"><span style=\"font-size: 18px;\">【决定书编号】无</span></p>\n<p style=\"line-height: 1.5;\"><span style=\"font-size: 18px;\">罚款缴纳二维码：</span></p>\n<p style=\"line-height: 1.5;\"><span style=\"font-size: 18px;\"><img style=\"width: 100%; display: block; margin: 0 auto;\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAJYAQAAAACWHaVxAAAECUlEQVR42u3dO7KrMAyAYTGnSJklsBSWliyNpWQJKVNk8A1YLwdy7inS+adJhoGPyoMsy0LK9w7BwsLCwsLCwsLCwsLCwsLK1l3suOh5+/vws/Opnn1dO70uGJ9+z4iFhTXU3+frrkXk5E+Y6lmRocyyXXw9b0+o11YDCwvrvl26jrHVWoeb/NRR+mJv9e/0EBuEk1r1AiwsrGzp62296zXy2kFoT1AWCwvryKp/1+OsQ1NsENpZESwsrI9xocd66yCc9dI6SsvNJ19/izGxsLqxIj+xjsdT8aH529//5jqwsLqx8uFzq6u+08b0sNdZGf6ec8fC6sXSbN5NtglVek9pclwUWFMVZYsLmyQgFhaW+Mh7W1VqJlRbXBgJDJ2HYWFhFY317NDkeGkSe5v1k3MZWwLjgYWFZblvOzlLLnRYAQ0GPWtRJ1RXfS4WFlZ6TxUvadgKHU4x43p4AkNDxPQELKzercEz4vWuOs1a4vW2+ORLl53aoYmF1bmlBXc3z5PXu4acn/DXW6p5OJpbYWH1aNl8qcZ6UxsBxuEFrnWadT0vR3EhFlaHlmYiohbIUuazeIiohQ72plN2n5/AwurSSpsnfELVDM2IFq0ML5KAIxYWVsm1QG9zq42tmQhJ06yan5h39atYWF1aS15gmq1CSMLaFee1F2BhYVl1wzryNIUnQzO30vyE7qOI3RVYWFhmjbql4pErVZv61bQXqYkhsbCwUu7bqhvkfZefJyVKsVzGvn4VC6tHK21u1RKi7e2V9vPpE9JeJE+vY2FhNXGhRIVQiv/ckhwtDsf5Qiys7qx7U0Q3a7V3Sb0ZNMfnuytsX/ksWFhYsWNCF2nbgrvi5Q8p3ecXfFr7xcLqzfIAb/EKobu3XvClWx+EVoYnh+tWWFg9WloLFEtJuSLvHIu0acDesbCwYm5Vcs7BqxuiO2reR2ENUD7UIGFhdWfVBSYvFopBKKlnatm33GpaOmBhdWy1xUIaAeo0S9rjEs+9HK/XYmF1aO17d4vvo/Cah1MTF0ZVKxYWlhULjWmLedsCKPoOe8utT/WrWFg9WqXEcmxK7KXGQEtkIpZmaIpgYWFpcrwBnl743W7ty1mL1D4VC6tvy95pXp6aPq+X9lF4UuKRq4mwsLDyoXk7nVt5tNhU5E3t2RELq3vr/p7Cy8tOkbXYpcw/7aPAwurOiu+BvfUISjsmtJldiWlWFEVgYWHNqe9w+0096/doOb5i5eC6j+Jzzh0Lq0treS/xTo1SU+/uPIyxsLAaywvuorlWnkX5DqXf+w5jYXVmeVzYdGHQCDB/fOV81IgLC6t3K+Un9E98gTIapVqfrSnmYYffA8PC6s76yoGFhYWFhYWFhYWFhYWFhfV96x9XyZQSnErqpgAAAABJRU5ErkJggg==\"/></span></p>\n<p style=\"line-height: 1.5;\"><span style=\"font-size: 18px;\">【当事人】Xiao</span></p>\n<p style=\"line-height: 1.5;\"><span style=\"font-size: 18px;\">【性别】男</span></p>\n<p style=\"line-height: 1.5;\"><span style=\"font-size: 18px;\">【证件号】530***********2533</span></p>\n<p style=\"line-height: 1.5;\"><span style=\"font-size: 18px;\">【地址】宣威</span></p>\n<p style=\"line-height: 1.5;\"><span style=\"font-size: 18px;\">【电话】153****4584</span></p>\n<p style=\"line-height: 1.5;\"><span style=\"font-size: 18px;\">&nbsp; &nbsp; 你（单位）于2024-01-11，无，违反了《中华人民共和国道路运输条例》第四十七条的规定，依据《中华人民共和国道路运输条例》第六十三条的规定，决定给予罚款人民币50.00的行政处罚。<br />&nbsp; &nbsp; 处罚履行方式：在线电子支付<br />&nbsp; &nbsp; 如不服本处罚决定，可根据《中华人民共和国行政复议法》，在收到本决定之日起60日内向人民政府申请行政复议，或者根据《中华人民共和国行政诉讼法》在6个月内向人民法院提起行政诉讼。逾期不申请行政复议或者不向人民法院起诉又不履行处罚决定的，我机关将依法强制执行或者申请人民法院强制执行。<br />执法人员：无<br />执法人员：无<br />2024-01-11<br /></span></p>\n<p style=\"line-height: 1.5;\"><span style=\"font-size: 18px;\"></span></p>\n<p style=\"line-height: 1.5;\"><span style=\"font-size: 18px;\"></span></p>\n<p style=\"padding-left: 40px; line-height: 1.5;\"><span style=\"font-size: 18px;\"></span></p>\n<p style=\"line-height: 1.5;\">&nbsp;</p>"
          // }

          this.sealImg = res.data.result.deptSignet || ''
          this.isSign = res.data.result.dsrSignet || ''
          this.signTime = res.data.result.signTime || ''
          this.textContent = res.data.result.content || ''
        } else {
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            message: res.data.message
          });
        }
      })
    },
    onClickLeft() {
      this.$router.push({
        path: this.$route.query.fullPath
      })
    },
  }
}
</script>

<style lang="scss">
.printPaymentSlip {
  min-height: calc(100vh - 46px);
  background-image: url("../../assets/img/backLogin.png");
  background-size: 100% 100%;

  .printPaymentSlip_top {
    margin: 0 15px;
    margin-top: 10px;
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px 10px 0 0;
    min-height: calc(100vh - 56px);

    .textContent {
      min-height: 182px;
      padding: 8px 20px;
      word-break: break-all;
      margin-bottom: 10px;
    }

    .sealImg {
      margin-bottom: 20px;
      width: 100%;
      display: flex;
      justify-content: center;

      img {
        //width: 180px;
        height: 180px;
      }

    }

    .signTime {
      font-size: 14px;
      color: #464A4C;
      letter-spacing: 0;
      font-weight: 400;
      text-align: right;
      padding-right: 22px;
    }

    .signStyle {
      p {
        font-size: 14px;
        color: #464A4C;
        letter-spacing: 0;
        font-weight: 400;
        text-indent: 22px;
      }


      .defaultSign {
        background: rgba(32, 143, 255, 0.10);
        border: 0.5px dashed rgba(32, 143, 255, 1);
        border-radius: 6px;
        font-size: 18px;
        color: #208FFF;
        letter-spacing: 0;
        text-align: center;
        font-weight: 500;
        margin: 10px 22px;
        height: 100px;
        line-height: 100px;
      }

      .signDiv {
        height: 100px;
        border-radius: 6px;
        margin: 10px 22px;
        position: relative;

        span {
          position: absolute;
          z-index: 1;
          //background: #a6a6a6;
          //opacity: 0.5;
          background: rgba(0, 0, 0, .6);
          display: block;
          width: 100%;
          height: 100%;
          font-size: 18px;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          font-weight: 500;
          line-height: 100px;
        }

        img {
          position: absolute;
          z-index: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

.customNavBar {
  background: transparent;

  .van-nav-bar__title {
    color: #fff !important;
  }

  .van-icon {
    color: #fff !important;
  }

}

.van-hairline--bottom::after {
  display: none;
}

.printconfirm {
  width: 305px;
  height: 44px;
  color: #fff !important;
  background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
  border-radius: 22px;
  margin: 0 auto;

  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 700;
  bottom: 42px;
  left: 50%;
  margin-left: -152px;
  margin-bottom: 10px;
  margin-top: 70px;

  .blueSha {
    width: 286px;
    height: 34px;
    position: absolute;
    left: 50%;
    top: 68%;
    transform: translateX(-50%);
  }
}
</style>
